import { Box, Typography } from '@mui/material';
import { IconMessage } from '@act/storybook';
import { useEffect, useState } from 'react';

const NoAccessPage = () => {
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'grid',
        justifyItems: 'center',
        alignContent: 'center',
      }}
    >
      <Box sx={{ maxWidth: '480px', textAlign: 'center' }}>
        <IconMessage
          message="Access Denied"
          subMessage={`You do not currently have access to the Reema Health application. If you believe this is a mistake, please contact your administrator for assistance.`}
          iconName="Prohibit"
          iconColor="error"
        />
        {countdown > 0 ? (
          <Typography variant="bodyMedium">
            You will be logged out in{' '}
            <Typography variant="bodyMedium" fontWeight="bold">
              {countdown} second
              {countdown !== 1 ? 's' : ''}
            </Typography>
            .
          </Typography>
        ) : (
          <Typography variant="bodyMedium" fontWeight="bold">
            Redirecting to login...
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default NoAccessPage;
